import { getOptions } from './options';
import { perfNow } from './time';
import { w } from './globals';

export const getPageLocation = () => w.location;

/**
 * Loads CSS based on the given content.
 *
 * @param {string} cssText The text content for the CSS to be loaded.
 */
export function loadCss(cssText: string): void {
    let doc = document;
    let style = doc.createElement('style');
    style.type = 'text/css';

    // Nonce value for CSP
    if (window && window.hasOwnProperty('cspNonce')) {
        const nonce = (window as any).cspNonce;
        if (nonce) {
            style.setAttribute('nonce', nonce);
        }
    }

    // TODO: trevori - bring over the isIE8 stuff.
    // First check for IE8-10 stylesheet property but only use it for IE8
    //if (isIE8 && style.styleSheet) {
    //    style.styleSheet.cssText = cssText;
    //}
    //else {
    //    style.appendChild(document.createTextNode(cssText));
    //}
    style.appendChild(document.createTextNode(cssText));

    const options = getOptions();

    // When used in web components, append style element to the shadowDOM container element instead of head.
    if (options && options.shadowDOMContainerElement && options.shadowDOMContainerElement.appendChild) {
        options.shadowDOMContainerElement.appendChild(style);
        return;
    }

    let head = doc.head || doc.getElementsByTagName('head')[0];
    head.appendChild(style);
}

export const requestAnimationFrame: Window["requestAnimationFrame"] =
    w.requestAnimationFrame
        ? cb => w.requestAnimationFrame(cb)
        : cb => setTimeout(() => cb(perfNow()));

// Constants used for createId() below
const idPrefix = 'mectrl';
const idSeparator = '_';
const prefixTester = new RegExp(`^${idPrefix}`, 'i'); // Regex to test if the string starts with the prefix

/**
 * Create a Me Control ID for html elements. Has a unique Me Control prefix
 * @param idParts Parts of the ID that will be concatenated as part of the ID
 */
export function createId(...idParts: (number | string)[]): string {
    let joinedParts = idParts.join(idSeparator);
    if (!prefixTester.test(joinedParts)) {
        joinedParts = idPrefix + idSeparator + joinedParts;
    }
    return joinedParts;
}
